<template>
  <Container>
    <div class="fee-tool">
      <div class="fee-toolbar">
        <div style="font-size:13px;color:var(--subtext2)">
          浙价服〔2009〕84号 · 填入造价及折扣率即可（本地测算）
        </div>
        <div class="flex-wrap split5">
          <Checkbox v-model="float20" @on-change="recalcAll">装饰/安装/园林等上浮20%</Checkbox>
          <Button icon="md-refresh" @click="reset">重置</Button>
        </div>
      </div>

      <div class="fee-card">
        <div class="fee-card-title">全局折扣（可被单项覆盖）</div>
        <div class="fee-form-row">
          <div class="fee-field">
            <label>默认折扣率（如 0.6 表示六折）</label>
            <InputNumber
              v-model="globalDiscount"
              :min="0"
              :max="2"
              :step="0.05"
              :active-change="false"
              style="width:100%"
              @on-change="applyGlobalDiscount"
            />
          </div>
        </div>
        <div class="fee-hint">每件咨询服务合同按上表计算不足 2000 元的，按 2000 元收费。</div>
      </div>

      <div class="fee-card fee-item-table">
        <div class="fee-card-title">咨询项目测算</div>
        <Table :columns="columns" :data="rows" border size="small" :span-method="spanMethod" />
        <div class="fee-summary" style="margin-top:14px">
          <div class="fee-sum-item highlight">
            <span class="label">已勾选项目收费合计</span>
            <span class="value">{{ fmtYuan(totalCharged) }} 元</span>
          </div>
          <div class="fee-sum-item">
            <span class="label">标准收费合计</span>
            <span class="value">{{ fmtYuan(totalStandard) }} 元</span>
          </div>
        </div>
      </div>

      <div class="fee-card">
        <div class="fee-card-title">说明</div>
        <div class="fee-notes">{{ notes }}</div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import {
  COST_CONSULTING_ITEMS,
  calcCostConsultingFee,
  calcSettlementExtra,
} from './fee-calc';

export default {
  components: {Container},
  data() {
    return {
      float20: false,
      globalDiscount: 0.6,
      rows: [],
      notes: `1、每件咨询服务合同按上表计算不足2000元的，按2000元收费；
2、单独委托的装饰、安装、园林绿化及仿古建筑工程的基本费率可在上述基准收费标准的基础上上浮20%；
3、核减（增）额的定义说明：清单漏项、工程量计算错误，小数点错误或合价计算错误等可计入核减（增）额；由于定额错套引起的价格变动的差价，应计入核减（增）额的收费基数；
4、施工阶段全过程造价控制，不包含各类招标代理和结算审核费用；
5、本标准所列工作内容不含钢筋及预埋件的单独计算，如需单独计算按5元/吨标准收费。`,
      columns: [
        {
          title: ' ',
          key: 'checked',
          width: 48,
          align: 'center',
          render: (h, {row, index}) => {
            if (row.isExtra) return h('span', '');
            return h('Checkbox', {
              props: {value: row.checked},
              on: {
                'on-change': (v) => {
                  this.$set(this.rows[index], 'checked', v);
                  this.syncExtraParent();
                },
              },
            });
          },
        },
        {title: '序号', key: 'noLabel', width: 60, align: 'center'},
        {title: '咨询项目', key: 'name', minWidth: 220},
        {title: '收费基数', key: 'baseLabel', width: 120},
        {
          title: '造价(万元)',
          key: 'costWan',
          width: 130,
          render: (h, {row, index}) =>
            h('InputNumber', {
              props: {
                value: row.costWan,
                min: 0,
                activeChange: false,
                size: 'small',
              },
              style: {width: '100%'},
              on: {
                'on-change': (v) => {
                  this.rows[index].costWan = v;
                  this.recalcRow(index);
                },
              },
            }),
        },
        {
          title: '折扣率',
          key: 'discount',
          width: 110,
          render: (h, {row, index}) =>
            h('InputNumber', {
              props: {
                value: row.discount,
                min: 0,
                max: 2,
                step: 0.05,
                activeChange: false,
                size: 'small',
              },
              style: {width: '100%'},
              on: {
                'on-change': (v) => {
                  this.rows[index].discount = v;
                  this.recalcRow(index);
                },
              },
            }),
        },
        {
          title: '标准收费(元)',
          key: 'standardYuan',
          width: 130,
          align: 'right',
          render: (h, {row}) => h('span', this.fmtYuan(row.standardYuan)),
        },
        {
          title: '折后收费(元)',
          key: 'chargedYuan',
          width: 130,
          align: 'right',
          render: (h, {row}) =>
            h(
              'span',
              {style: {fontWeight: 600, color: '#2d8cf0'}},
              this.fmtYuan(row.chargedYuan) + (row.belowMin ? ' *' : ''),
            ),
        },
      ],
    };
  },
  computed: {
    totalCharged() {
      return this.rows
        .filter((r) => (r.isExtra ? r.parentChecked : r.checked))
        .reduce((s, r) => s + (Number(r.chargedYuan) || 0), 0);
    },
    totalStandard() {
      return this.rows
        .filter((r) => (r.isExtra ? r.parentChecked : r.checked))
        .reduce((s, r) => s + (Number(r.standardYuan) || 0), 0);
    },
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.float20 = false;
      this.globalDiscount = 0.6;
      const rows = [];
      COST_CONSULTING_ITEMS.forEach((item) => {
        const costDefault = [1, 2, 5, 8, 9, 10].includes(item.no)
          ? item.no === 9
            ? 120000
            : item.no === 10
              ? 100000
              : 40000
          : 1;
        rows.push({
          key: item.key,
          no: item.no,
          noLabel: String(item.no),
          name: item.group ? `${item.group} · ${item.name}` : item.name,
          baseLabel: item.baseLabel,
          rates: item.rates,
          checked: item.no === 1,
          costWan: costDefault,
          discount: this.globalDiscount,
          standardYuan: 0,
          chargedYuan: 0,
          belowMin: false,
          isExtra: false,
          group: item.group || '',
        });
        if (item.extra) {
          rows.push({
            key: item.extra.key,
            no: item.no,
            noLabel: '',
            name: item.extra.name,
            baseLabel: '核增减额',
            checked: false,
            parentKey: item.key,
            parentChecked: item.no === 1,
            costWan: 1,
            discount: this.globalDiscount,
            standardYuan: 0,
            chargedYuan: 0,
            belowMin: false,
            isExtra: true,
          });
        }
      });
      this.rows = rows;
      this.recalcAll();
    },
    applyGlobalDiscount() {
      this.rows.forEach((r) => {
        r.discount = this.globalDiscount;
      });
      this.recalcAll();
    },
    recalcAll() {
      this.rows.forEach((_, i) => this.recalcRow(i, false));
      this.syncExtraParent();
    },
    syncExtraParent() {
      this.rows.forEach((r) => {
        if (r.isExtra) {
          const parent = this.rows.find((x) => x.key === r.parentKey);
          r.parentChecked = !!(parent && parent.checked);
        }
      });
    },
    recalcRow(index, sync = true) {
      const row = this.rows[index];
      if (!row) return;
      if (row.isExtra) {
        const r = calcSettlementExtra(row.costWan, row.discount);
        row.standardYuan = r.standardYuan;
        row.chargedYuan = r.chargedYuan;
        row.belowMin = false;
      } else {
        const r = calcCostConsultingFee(row.costWan, row.rates, row.discount, {
          float20: this.float20,
        });
        row.standardYuan = r.standardYuan;
        row.chargedYuan = r.chargedYuan;
        row.belowMin = r.belowMin;
      }
      if (sync) this.syncExtraParent();
      this.$forceUpdate();
    },
    spanMethod() {
      return {};
    },
    fmtYuan(v) {
      const n = Number(v) || 0;
      return n.toLocaleString('zh-CN', {maximumFractionDigits: 2});
    },
  },
};
</script>

<style lang="less" scoped>
@import './fee-tool.less';
</style>
